
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageHelper {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  setItem(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(btoa(key), btoa(value));
    }
  }

  getItem(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      const encodedKey = btoa(key);
      const encodedValue = localStorage.getItem(encodedKey);
      if (encodedValue) {
        return atob(encodedValue);
      }
    }
    return null;
  }

  removeItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(btoa(key));
    }
  }

  clear(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }
}
